module.exports = __webpack_public_path__ + "static/img/img_18.5b67ff92.png";